import script from "./EditPropertiesDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditPropertiesDialog.vue?vue&type=script&setup=true&lang=ts"

import "./EditPropertiesDialog.vue?vue&type=style&index=0&id=3cbbf368&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cbbf368"]])

export default __exports__